var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerrae(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_18438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.947 19.3564C27.8021 18.9452 27.4548 18.7355 26.9131 18.7355C19.9735 18.7355 13.0348 18.7355 6.09521 18.7355C6.00523 18.7355 5.91525 18.7337 5.82616 18.7427C5.35734 18.7922 4.99291 19.207 5.0001 19.6803C5.0073 20.1483 5.36634 20.5406 5.83156 20.5856C5.95754 20.5973 6.08352 20.6 6.24639 20.609V20.8969C6.24639 22.3043 6.24639 23.7107 6.24639 25.1181C6.24639 25.8353 6.60633 26.1943 7.3226 26.1943C13.4388 26.1943 19.5542 26.1907 25.6704 26.2006C26.2634 26.2015 26.7745 25.847 26.761 25.1019C26.7358 23.6954 26.7538 22.2881 26.7538 20.8807V20.609C26.9104 20.6 27.0364 20.5973 27.1615 20.5856C27.7617 20.5289 28.1468 19.9251 27.9461 19.3564H27.947ZM9.95735 24.3118H8.12166V20.618H9.95735V24.3118ZM13.6908 24.3046H11.8497V20.6081H13.6908V24.3046ZM17.4198 24.3037H15.5805V20.6072H17.4198V24.3037ZM21.1532 24.31H19.3094V20.6126H21.1532V24.31ZM24.8804 24.3118H23.0429V20.6153H24.8804V24.3118Z",
    fill: "#C0C8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5471 12.8447H10.4531V16.8562H15.548V12.8447H15.5471Z",
    fill: "#C0C8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4492 16.8505H22.554V12.8408H17.4492V16.8505Z",
    fill: "#C0C8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5572 6C12.9854 6.37164 10.9131 8.48807 10.5405 10.9491H15.5572V6Z",
    fill: "#C0C8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 6.00586V10.9514H22.4625C22.0414 8.30856 19.8233 6.319 17.4468 6.00586Z",
    fill: "#C0C8D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_18438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20.2015,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrae);
export default __webpack_public_path__ + "static/media/terraсe.9a9e8476eb2e7ee5c69d099c0fe2dad4.svg";
export { ForwardRef as ReactComponent };